import { ReactElement, useContext } from "react"

import AttachmentArrayBase from "./attachmentArrayBase"
import { IUpload } from "../../../../services/middleware/types/singleApplication/uploadAttachmentTypes"
import { ApplicationContext } from "../applicationProvider"

interface IAttachmentArrayProps {
    formKey: string
    minItems: number
    fileUrlKey: string
    imageMode: boolean
    initialUploads?: IUpload[]
    maxItems?: number
}

/** Attachment array generator specific to application context for
 * installer single application form
 */
const AttachmentArray = ({
    formKey,
    minItems,
    fileUrlKey,
    imageMode,
    initialUploads = [],
    maxItems,
}: IAttachmentArrayProps): ReactElement => {
    const {
        setFormData,
        setCurrentStepIndex,
        setSupplementingInfo,
        isFirstStep,
        onClickBackFirstStep,
    } = useContext(ApplicationContext)

    return (
        <AttachmentArrayBase
            formKey={formKey}
            minItems={minItems}
            fileUrlKey={fileUrlKey}
            imageMode={imageMode}
            initialUploads={initialUploads}
            maxItems={maxItems}
            setFormData={setFormData}
            setCurrentStepIndex={setCurrentStepIndex}
            setSupplementingInfo={setSupplementingInfo}
            isFirstStep={isFirstStep}
            onClickBackFirstStep={onClickBackFirstStep}
        />
    )
}

AttachmentArray.defaultProps = {
    initialUploads: [],
    maxItems: undefined,
}

export default AttachmentArray
